export default "__VITE_ASSET__EyZbx0vQ__"